if (!customElements.get("deployer-product-page-upsell")) {
  customElements.define(
    "deployer-product-page-upsell",
    class DeployerPageProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.selects = this.querySelectorAll(".dppu-bunde-product--select");
        this.variantsData = {};
        this.form =
          this.querySelector('.product-form form[action="/cart/add"]') ||
          this.querySelector('.product__page form[action="/cart/add"]') ||
          this.querySelector('.product form[action="/cart/add"]') ||
          this.querySelector('form[action="/cart/add.js"]') ||
          this.querySelector('form[action="/cart/add"]');
        this.formInputs = this.form.querySelectorAll("input");
        this.submitButton = this.form.querySelector('[name="add"]');
        this.discountType = this.dataset.discountType;
        this.dynamicSaving = this.dataset.dynamicSaving;
      }

      connectedCallback() {
        this.selects.forEach((select) => {
          select.addEventListener("change", this.handleSelectChange.bind(this));
        });
      }

      async handleSelectChange(event) {
        this.submitButton.disabled = true;
        await this.getSelectedVariantsData();
        this.updateBundlePrices();
        this.formInputs.forEach((input) => {
          if (!this.variantsData[input.dataset.handle]) return;
          const variantId = this.variantsData[input.dataset.handle].id;
          input.value = variantId;
        });
        const available = Object.values(this.variantsData).every((variant) => variant.available);
        this.submitButton.disabled = false;
        this.toggleAvailability(available);
        if (this.dataset.dynamicVariantImage === "false" && parseInt(this.dataset.bundleSize) == 1) {
          this.updateImage();
        }
      }

      updateBundlePrices() {
        const priceContainer = this.querySelector(".dppu-bundle--button-price");
        const compareAtPriceContainer = this.querySelector(".dppu-bundle--button-compare-at-price");
        if (!priceContainer) return;
        // add all of variants prices to get the total price
        const totalPrice = Object.values(this.variantsData).reduce((acc, variant) => acc + variant.price, 0);
        priceContainer.innerText = formatPrice(totalPrice);
        // add all the compare at prices to get the total compare at price
        const totalCompareAtPrice = Object.values(this.variantsData).reduce((acc, variant) => acc + variant.compare_at_price, 0);
        if (totalCompareAtPrice === 0) return;
        compareAtPriceContainer.innerText = formatPrice(totalCompareAtPrice);
        if (!this.dynamicSaving) return;
        if (totalCompareAtPrice > totalPrice) {
          this.dynamicSavingContainer = this.querySelector(".dppu-dynamic-saving");
          if (this.dynamicSavingContainer && this.discountType === "percentage") {
            const discount = Math.round(((totalCompareAtPrice - totalPrice) / totalCompareAtPrice) * 100);
            this.dynamicSavingContainer.innerHTML = `${discount.toFixed(0)}%`;
          } else if (this.dynamicSavingContainer && this.discountType !== "percentage") {
            const discount = totalCompareAtPrice - totalPrice;
            this.dynamicSavingContainer.innerHTML = formatPrice(discount);
          }
        }
      }

      updateImage() {
        const image = this.querySelector(".dppu-image");
        const variant = this.variantsData[Object.keys(this.variantsData)[0]];
        if (!variant.featured_image) return;
        image.src = variant.featured_image.src;
      }

      toggleAvailability(available) {
        if (available) {
          this.submitButton.disabled = false;
          this.submitButton.querySelector("span:nth-child(1)").innerText = this.submitButton.dataset.addToCartText;
          if (this.submitButton.querySelector("deployer-button__price")) this.submitButton.querySelector("deployer-button__price").style.display = "block";
        } else {
          this.submitButton.disabled = true;
          this.submitButton.querySelector("span:nth-child(1)").innerText = this.submitButton.dataset.soldOutText;
          if (this.submitButton.querySelector("deployer-button__price")) this.submitButton.querySelector("deployer-button__price").style.display = "none";
        }
      }

      async getSelectedVariantsData() {
        this.variantsData = {};
        for (const select of this.selects) {
          const selectedValue = select[select.selectedIndex].value;
          const variant = await this.getVariantData(select.dataset.handle, selectedValue);
          this.variantsData[select.dataset.handle] = variant;
        }
      }

      async getVariantData(productHandle, variantId) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          const data = await response.json();
          const variant = data.variants.find((variant) => variant.id === parseInt(variantId));
          return variant;
        } catch (error) {
          console.error("Error:", error);
        }
      }
    }
  );
}
